import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2btsty9cs: FaireProductEntity = {
  token: "p_z2btsty9cs",
  type: "product",
  name: "Dubai Chocolate Cones - with Pistachio Cream - x2 the Luxury",
  brandToken: "b_6w2wcf7tpu",
  brandName: "Mr. YuYu's Chililicious Candy",
  imageUrl: "https://cdn.faire.com/fastly/44132fd27e58f90f5e563a8c403f1a00ad222ba0b60383ceae86f3957395f7da.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.27,
  description: "Delight your customers with Dubai Chocolate Cones – Pistachio Cream x2 the Luxury from Mr YuYu’s Wholesale. This 10-count wholesale pack features premium chocolate cones filled with rich, velvety pistachio cream for a luxurious snacking experience.\n\nEach cone delivers the perfect balance of smooth chocolate and creamy pistachio, offering twice the indulgence for discerning palates. Individually packaged for freshness and convenience, these cones are ideal for specialty retailers, gift shops, gourmet markets, and high-end snack sections seeking premium, differentiated chocolate offerings.\n\nStock Dubai Chocolate Cones – Pistachio Cream x2 the Luxury to provide your customers with an exquisite, memorable treat that encourages repeat purchases and elevates your dessert and snack inventory.\n",
  tags: [],
  msrpDollars: 10.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:54.368Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
